// Domain part follows the rules browsers apply to <input type="email">: dot
// separated labels, no leading or trailing hyphen, no empty label. The local
// part is deliberately narrower than the spec, to match the one format check
// the API does (inbiot-private-api-user addProjectAlertRecipient), so we never
// accept an address the backend then rejects. The report modals used to take
// any non-space local part, so they are tightened by this too, on purpose.
export const EMAIL_REGEX =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/
